export default {
  get() {
    let darkTheme = window.localStorage.getItem('darkTheme')

    return darkTheme && darkTheme !== "undefined" ? JSON.parse(darkTheme) : false
  },
  set(user) {
    window.localStorage.setItem('darkTheme', JSON.stringify(user))
  },
  remove() {
    window.localStorage.removeItem('darkTheme')
  }
}
